export default "__VITE_ASSET__D_Vd3zEl__"